import {FC, useMemo} from 'react'
import find from 'lodash/find'
import {Dropdown} from 'react-bootstrap'
import {globalFilter} from 'app/constant'

const statusTypes = [
  {
    id: 'PAID',
    name: 'Paid',
  },
  {
    id: 'PENDING',
    name: 'Unpaid',
  },
  {
    id: 'PAYMENT_FAILED',
    name: 'Failed',
  },
  {
    id: 'PARTIALLY_PAID',
    name: 'Partially Paid',
  },
  {
    id: 'REFUNDED',
    name: 'Refunded',
  },
  {
    id: 'PARTIALLY_REFUNDED',
    name: 'Partially Refunded',
  },
]

type Props = {
  filter: any
  setFilter: (value: any) => any
}

const PaymentStatusFilter: FC<Props> = ({filter, setFilter}) => {
  const handleChange = (paymentStatus: any) => {
    let financialStatus
    if (paymentStatus === '') {
      financialStatus = null
    } else {
      financialStatus = paymentStatus
    }
    setFilter({...filter, financialStatus, offset: 0})
  }

  const filterName = useMemo(() => {
    if (filter.financialStatus) {
      const result = find(statusTypes, {id: filter.financialStatus})
      if (result) {
        return result.name
      }
    }
    return 'Payment Status'
  }, [filter.financialStatus])

  return (
    <Dropdown>
      <Dropdown.Toggle variant='transparent' className={`${globalFilter.css} px-4 mt-1`}>
        {filterName}
      </Dropdown.Toggle>
      <Dropdown.Menu className='form-control border-dark border mt-1 ms-1'>
        <Dropdown.Item eventKey='' as='button' onSelect={handleChange}>
          All
        </Dropdown.Item>
        {statusTypes.map((status) => (
          <Dropdown.Item key={status.id} eventKey={status.id} as='button' onSelect={handleChange}>
            {status.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default PaymentStatusFilter
